declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initPixel() {
  if (initialized) return
  initialized = true

  // Setup fbq function
  if (!window.fbq) {
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Load Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Also add noscript image pixel as fallback
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=3329990210505909&ev=PageView&noscript=1'
  document.body.appendChild(img)

  // Init and track PageView
  window.fbq('init', '3329990210505909')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Código del Vientre',
      value: 14,
      currency: 'USD',
    })
  }
}
